var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { boxesState } from '~/state/boxes';
import { addWindowEventListener, removeWindowEventListener, } from '~/utils/windowEventListen';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #eee;\n  opacity: 0.8;\n  position: fixed;\n  width: 600px;\n  height: 100%;\n  right: 0;\n  padding: 20px;\n  overflow: scroll;\n  word-break: break-all;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n\n  @media only screen and (max-width: 375px) {\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    width: 100%;\n    height: 250px;\n    bottom: 0;\n  }\n\n  input {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n"], ["\n  background-color: #eee;\n  opacity: 0.8;\n  position: fixed;\n  width: 600px;\n  height: 100%;\n  right: 0;\n  padding: 20px;\n  overflow: scroll;\n  word-break: break-all;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n\n  @media only screen and (max-width: 375px) {\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    width: 100%;\n    height: 250px;\n    bottom: 0;\n  }\n\n  input {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n"])));
export function Console() {
    var _a = __read(useState({}), 2), log = _a[0], setLog = _a[1];
    var _b = __read(useState(''), 2), filter = _b[0], setFilter = _b[1];
    var boxes = useRecoilValue(boxesState);
    useEffect(function () {
        setLog(function (log) { return (__assign(__assign({}, log), boxes.reduce(function (obj, box) {
            var name = box.name, boundingClientRect = box.boundingClientRect, clientLeft = box.clientLeft, clientTop = box.clientTop, clientWidth = box.clientWidth, clientHeight = box.clientHeight, scrollWidth = box.scrollWidth, scrollHeight = box.scrollHeight, scrollTop = box.scrollTop, scrollLeft = box.scrollLeft, offsetWidth = box.offsetWidth, offsetHeight = box.offsetHeight;
            obj["".concat(name, ".element.boundingClientRect.x")] = boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.x;
            obj["".concat(name, ".element.boundingClientRect.y")] = boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.y;
            obj["".concat(name, ".element.boundingClientRect.top")] = boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.top;
            obj["".concat(name, ".element.boundingClientRect.right")] =
                boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.right;
            obj["".concat(name, ".element.boundingClientRect.bottom")] =
                boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.bottom;
            obj["".concat(name, ".element.boundingClientRect.left")] =
                boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.left;
            obj["".concat(name, ".element.boundingClientRect.width")] =
                boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.width;
            obj["".concat(name, ".element.boundingClientRect.height")] =
                boundingClientRect === null || boundingClientRect === void 0 ? void 0 : boundingClientRect.height;
            obj["".concat(name, ".element.clientLeft")] = clientLeft;
            obj["".concat(name, ".element.clientTop")] = clientTop;
            obj["".concat(name, ".element.clientWidth")] = clientWidth;
            obj["".concat(name, ".element.clientHeight")] = clientHeight;
            obj["".concat(name, ".element.offsetWidth")] = offsetWidth;
            obj["".concat(name, ".element.offsetHeight")] = offsetHeight;
            obj["".concat(name, ".element.scrollWidth")] = scrollWidth;
            obj["".concat(name, ".element.scrollHeight")] = scrollHeight;
            obj["".concat(name, ".element.scrollTop")] = scrollTop;
            obj["".concat(name, ".element.scrollLeft")] = scrollLeft;
            return obj;
        }, {}))); });
    }, [boxes]);
    useEffect(function () {
        var updateLog = function () {
            setLog(function (log) {
                var _a;
                return (__assign(__assign({}, log), (_a = {}, _a['document.documentElement.clientWidth'] = document.documentElement.clientWidth, _a['document.documentElement.clientHeight'] = document.documentElement.clientHeight, _a['document.documentElement.offsetWidth'] = document.documentElement.offsetWidth, _a['document.documentElement.offsetHeight'] = document.documentElement.offsetHeight, _a['document.documentElement.scrollWidth'] = document.documentElement.scrollWidth, _a['document.documentElement.scrollHeight'] = document.documentElement.scrollHeight, _a['document.body.clientWidth'] = document.body.clientWidth, _a['document.body.clientHeight'] = document.body.clientHeight, _a['document.body.offsetWidth'] = document.body.offsetWidth, _a['document.body.offsetHeight'] = document.body.offsetHeight, _a['document.body.scrollWidth'] = document.body.scrollWidth, _a['document.body.scrollHeight'] = document.body.scrollHeight, _a['document.documentElement.scrollLeft'] = document.documentElement.scrollLeft, _a['document.documentElement.scrollTop'] = document.documentElement.scrollTop, _a['document.body.scrollLeft'] = document.body.scrollLeft, _a['document.body.scrollTop'] = document.body.scrollTop, _a['window.pageXOffset'] = window.pageXOffset, _a['window.pageYOffset'] = window.pageYOffset, _a['window.scrollX'] = window.scrollX, _a['window.scrollY'] = window.scrollY, _a['window.innerWidth'] = window.innerWidth, _a['window.innerHeight'] = window.innerHeight, _a['window.screen.width'] = window.screen.width, _a['window.screen.height'] = window.screen.height, _a['window.visualViewport.offsetLeft'] = window.visualViewport.offsetLeft, _a['window.visualViewport.offsetTop'] = window.visualViewport.offsetTop, _a['window.visualViewport.pageLeft'] = window.visualViewport.pageLeft, _a['window.visualViewport.pageTop'] = window.visualViewport.pageTop, _a['window.visualViewport.width'] = window.visualViewport.width, _a['window.visualViewport.height'] = window.visualViewport.height, _a['window.visualViewport.scale'] = window.visualViewport.scale, _a)));
            });
        };
        var handleWindowResize = function () {
            updateLog();
        };
        var handleWindowScroll = function () {
            updateLog();
        };
        var handleWindowMouseMove = function (event) {
            var clientX = event.clientX, clientY = event.clientY, pageX = event.pageX, pageY = event.pageY;
            setLog(function (log) {
                var _a;
                return (__assign(__assign({}, log), (_a = {}, _a["windowMouseEvent.clientX"] = clientX, _a["windowMouseEvent.clientY"] = clientY, _a["windowMouseEvent.pageX"] = pageX, _a["windowMouseEvent.pageY"] = pageY, _a)));
            });
        };
        var handleTouchMove = function (event) {
            Array.from(event.touches).map(function (touch, index) {
                var clientX = touch.clientX, clientY = touch.clientY, pageX = touch.pageX, pageY = touch.pageY;
                setLog(function (log) {
                    var _a;
                    return (__assign(__assign({}, log), (_a = {}, _a["windowTouchEvent[".concat(index, "].clientX")] = clientX, _a["windowTouchEvent[".concat(index, "].clientY")] = clientY, _a["windowTouchEvent[".concat(index, "].pageX")] = pageX, _a["windowTouchEvent[".concat(index, "].pageY")] = pageY, _a)));
                });
            });
        };
        updateLog();
        addWindowEventListener('mousemove', handleWindowMouseMove);
        addWindowEventListener('touchmove', handleTouchMove);
        addWindowEventListener('scroll', handleWindowScroll);
        addWindowEventListener('resize', handleWindowResize);
        return function () {
            removeWindowEventListener('mousemove', handleWindowMouseMove);
            removeWindowEventListener('touchmove', handleTouchMove);
            removeWindowEventListener('scroll', handleWindowScroll);
            removeWindowEventListener('resize', handleWindowResize);
        };
    }, []);
    return (React.createElement(Container, null,
        React.createElement("input", { type: "text", placeholder: "filter", value: filter, onChange: function (event) { return setFilter(event.target.value); } }),
        Array.from(Object.entries(log))
            .filter(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key.toLowerCase().includes(filter.toLowerCase());
        })
            .sort(function (_a, _b) {
            var _c = __read(_a, 1), key1 = _c[0];
            var _d = __read(_b, 1), key2 = _d[0];
            return key1.localeCompare(key2);
        })
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (filter) {
                var parts = key.split(new RegExp("(".concat(filter, ")"), 'gi'));
                return (React.createElement("div", { key: key },
                    parts.map(function (part, i) { return (React.createElement("span", { key: i, style: part.toLowerCase() === filter.toLowerCase()
                            ? { fontWeight: 'bold' }
                            : {} }, part)); }),
                    ": ",
                    Math.floor(value)));
            }
            return (React.createElement("div", { key: key },
                key,
                ": ",
                Math.floor(value)));
        })));
}
var templateObject_1;
